import { gql } from '@apollo/client';

export const SEARCH = gql`
  query Search($term: String!, $includeInactive: Boolean, $limit: Int) {
    search(term: $term, includeInactive: $includeInactive, limit: $limit) {
      total
      results {
      ... on Asset {
        id
        vin
        lastSix
        stockNumber
        clientNumber
        name
        seller { id, name }
      }
      ... on Buyer {
        id
        name
        fullDisplayName
      }
      ... on Sale {
        id
        name
      }
      ... on SaleAsset {
        id
        lotNumber
        asset {
          id
          vin
          lastSix
          stockNumber
          name
          seller { id, name }
        }
        sale { saleOn }
      }
      ... on Seller {
        id
        name
      }
      ... on Vendor {
        id
        name
      }
      ... on BuyerUser {
        id
        fullNameCache
        paddleNumberCache
        buyer {
          id
          name
          fullDisplayName
        }
      }
      }
    }
  }
`;
